(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/self-exclusion-24.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/self-exclusion-24.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Button = svs.ui.ReactButton;
const _jotai = jotai,
  useAtom = _jotai.useAtom;
const Form = svs.ui.ReactForm.Form;
const activeExclusionsAtom = svs.selfExclusion.store.selfExclusionAtoms.activeExclusionsAtom;
const SelfExclusion24 = () => {
  const _useAtom = useAtom(activeExclusionsAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    setActiveExclusions = _useAtom2[1];
  const confirmSelfExclusion24 = e => {
    e.preventDefault();
    svs.accountservices.pause24.show(activeExclusions => {
      setActiveExclusions(svs.accountservices.player_exclusions.utils.asArray(activeExclusions));
    });
  };
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2",
    id: "self-exclusion-24"
  }, React.createElement(Form, {
    onSubmit: confirmSelfExclusion24
  }, React.createElement("div", null, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Spelpaus i 24 timmar"), React.createElement("p", null, "Genom att aktivera spelpausen nedan tar du en paus fr\xE5n alla v\xE5ra spel i 24 timmar.")), React.createElement(Button, {
    block: true,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Aktivera spelpaus 24"))), React.createElement("hr", {
    "aria-hidden": true,
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.SelfExclusion24 = SelfExclusion24;

 })(window);